/* @kdd-custom — S1 le quai d'expédition (/apps/parcelpanel).
   1. L'aiguille de la timeline suit l'étape survolée (décor ; sans JS elle
      reste posée sur « Préparation »).
   2. L'app ParcelPanel est une SPA : placeholders FR et « Powered by »
      masqué, ré-appliqués à chaque re-rendu via MutationObserver
      (méthode éprouvée sur Montrelio). */
(function () {
  function initTimeline() {
    var aiguille = document.querySelector('[data-kdd-sx-aiguille]');
    if (!aiguille || aiguille.hasAttribute('data-kdd-sx-actif')) return;
    aiguille.setAttribute('data-kdd-sx-actif', '');
    document.querySelectorAll('.kdd-sx__temp').forEach(function (t) {
      t.addEventListener('mouseenter', function () {
        aiguille.style.left = t.getAttribute('data-kdd-sx-pos') + '%';
      });
    });
  }

  /* Étapes du transporteur en français, neutres sur la provenance (méthode Montrelio 03.11). */
      var SUIVI_FR_EXACT = {
        'on fedex vehicle for delivery': 'Votre colis est en cours de livraison',
        'at local fedex facility': 'Colis arrivé sur un site logistique',
        'departed fedex hub': 'Colis parti du site logistique',
        'arrived at fedex hub': 'Colis arrivé sur un site logistique',
        'shipment information sent to fedex': 'Informations d’expédition enregistrées',
        'parcel data received': 'Informations d’expédition enregistrées',
        'your parcel will soon be handed over to us! it is being prepared by the sender': 'Votre colis est en préparation et sera bientôt remis au transporteur',
        'parcel received at sorting centre': 'Colis réceptionné au centre de tri',
        'parcel processed at sorting centre': 'Colis traité au centre de tri',
        'parcel departure in sorting centre': 'Colis parti du centre de tri',
        'customs declaration completed': 'Colis en cours d’acheminement',
        'parcel departure in transit facility': 'Colis parti du centre de transit',
        'parcel is leaving airport': 'Colis parti du site logistique',
        'parcel arrives at airport': 'Colis arrivé sur un site logistique',
        'custom clearance completed': 'Colis en cours d’acheminement',
        'clearence processing completed - export': 'Colis en cours d’acheminement',
        'clearance processing completed - import': 'Colis en cours d’acheminement',
        'collected at cargo terminal': 'Colis arrivé sur un site logistique',
        'noa received': 'Colis en cours d’acheminement',
        'departed from sort facility': 'Colis parti du centre de tri',
        'your item was delivered in the letterbox': 'Votre colis a été déposé dans votre boîte aux lettres'
      };
            var SUIVI_FR_GENERIQUE = /^(parcel |shipment )?(departure|arrival|leaving port|arrival port|departure port|in transit)$/i;
      var SUIVI_FR_REGLES = [
        [/china|chinese|hong ?kong|guangdong|guangzhou|shenzhen|shanghai|beijing|yiwu|[\u4e00-\u9fff]|export|import|origin|international|overseas|abroad|cargo|terminal|\bnoa\b/i, 'Colis en cours d’acheminement'],
        [/(data|information|info) (received|transmitted)|label (created|printed)|electronic (information|notification)|order (received|created)|pre-?advice/i, 'Informations d’expédition enregistrées'],
        [/handed over to us|prepared by the sender|awaiting (pick ?up|collection)|waiting for (pick ?up|collection)|ready (for|to be) (shipped|dispatched)/i, 'Votre colis est en préparation et sera bientôt remis au transporteur'],
        [/return(ed|ing)? to (the )?sender|return(ed)? shipment|being returned/i, 'Colis en retour vers l’expéditeur'],
        [/attempt|unable to deliver|could not be delivered|not delivered|failed|recipient (not available|absent)|no one (was )?(home|available)|address (incorrect|incomplete|unknown)/i, 'Tentative de livraison infructueuse : un avis de passage a pu être déposé'],
        [/(available|ready) for (pick ?up|collection)|pick ?up point|parcel ?(shop|locker)|relay point|collection point|post office/i, 'Votre colis est disponible dans votre point de retrait'],
        [/out for delivery|with (the )?(courier|driver|postman)|on (its|the) way to (you|the recipient|the consignee)|being delivered|delivery (in progress|scheduled)/i, 'Votre colis est en cours de livraison'],
        [/(handed|hand(ed)? over|handover|transferred|delivered|tendered|passed) to (the )?(last[- ]?mile|local|domestic|destination|final)|last[- ]?mile/i, 'Colis remis au transporteur local pour la livraison'],
        [/(ready|about|scheduled) to be delivered|will be delivered/i, 'Votre colis sera livré très prochainement'],
        [/letter ?box|mail ?box/i, 'Votre colis a été déposé dans votre boîte aux lettres'],
        [/^(?!.*(to be|will be|ready to be|being) delivered).*\b(delivered|delivery (completed|successful)|signed (for|by))\b/i, 'Votre colis a été livré'],
        [/custom.*(clearance|cleared).*(complet|finish|success|release)|cleared customs|released (by|from) customs|import clearance (complet|success)/i, 'Colis en cours d’acheminement'],
        [/(custom|export).*(declaration|clearance).*(complet|submit|success|finish)|export (declaration|clearance)/i, 'Colis en cours d’acheminement'],
        [/custom|clearance|duty|duties/i, 'Colis en cours d’acheminement'],
        [/arriv.*destination country|destination country.*arriv|arrived in (the )?destination|inbound in destination/i, 'Colis en cours d’acheminement'],
        [/(arriv|landed|reach).*airport|airport.*arriv|flight arriv|landed/i, 'Colis arrivé sur un site logistique'],
        [/(leav|left|depart).*airport|airport.*(depart|leav)|flight (depart|took off)/i, 'Colis parti du site logistique'],
        [/airline|flight|aircraft|air transport|in the air/i, 'Colis en cours d’acheminement'],
        [/(depart|left|leaving|dispatch).*(sorting|processing) (centre|center|facility)/i, 'Colis parti du centre de tri'],
        [/(receiv|arriv|accepted).*(sorting|processing|distribution|logistics) (centre|center|facility|hub|site)/i, 'Colis réceptionné au centre de tri'],
        [/(process|sort).*(centre|center|facility|hub|site)/i, 'Colis traité au centre de tri'],
        [/(depart|left|leaving|dispatch).*(transit|facility|hub|warehouse|depot)/i, 'Colis parti du centre de transit'],
        [/(arriv|receiv).*(transit|facility|hub|warehouse|depot)/i, 'Colis arrivé au centre de transit'],
        [/in transit|transiting|on (its|the) way/i, 'Colis en transit'],
        [/exception|delay|held|on hold|retained|damaged/i, 'Incident d’acheminement : nous suivons votre colis de près']
      ];
      function suiviFrSegment(s) {
        var cle = s.trim().replace(/[.\s]+$/, '').toLowerCase();
        if (SUIVI_FR_EXACT[cle]) return SUIVI_FR_EXACT[cle];
        if (!/[a-z]/i.test(cle) || /[àâçéèêëîïôûùü]/i.test(cle)) return s.trim();
        for (var i = 0; i < SUIVI_FR_REGLES.length; i++) {
          if (SUIVI_FR_REGLES[i][0].test(cle)) return SUIVI_FR_REGLES[i][1];
        }
        if (/\b(colis|votre|vos|envoi|livraison|livr[ée]|acheminement|transporteur|destinataire|bureau|retrait|distribution|tri)\b/i.test(cle)) return s.trim();
        return 'Colis en cours d’acheminement';
      }
      function suiviFrTexte(txt) {
        var segs = txt.split(/,\s+/);
        var sansLieu = segs.filter(function (s) { return /[a-zà-ÿ]/.test(s); });
        if (sansLieu.length) segs = sansLieu;
        if (segs.length > 1) {
          var utiles = segs.filter(function (s) { return !SUIVI_FR_GENERIQUE.test(s.trim()); });
          if (utiles.length) segs = utiles;
        }
        var vus = [];
        segs.forEach(function (s) {
          var fr = suiviFrSegment(s);
          if (fr && vus.indexOf(fr) === -1) vus.push(fr);
        });
        if (vus.length > 1) vus = vus.filter(function (v) { return v !== 'Colis en cours d’acheminement'; });
        return vus.join(', ');
      }
            var SUIVI_MOIS_EN = { jan: 'janv.', feb: 'févr.', mar: 'mars', apr: 'avr.', may: 'mai', jun: 'juin', jul: 'juil.', aug: 'août', sep: 'sept.', sept: 'sept.', oct: 'oct.', nov: 'nov.', dec: 'déc.' };
      var SUIVI_DATE_RE = /^\s*([A-Za-zÀ-ÿ]+\.?)\s+(\d{1,2})(?:,\s*(\d{4}))?(?:\s+(\d{1,2}):(\d{2})\s*([ap]\.?m\.?)?)?\s*$/i;
      function suiviDateFr(txt) {
        var m = txt.match(SUIVI_DATE_RE);
        if (!m) return txt;
        var mois = m[1];
        if (!/^(janv|févr|fevr|mars|avr|mai|juin|juil|août|aout|sept|oct|nov|déc|dec|jan|feb|mar|apr|may|jun|jul|aug|sep)/i.test(mois)) return txt;
        var en =SUIVI_MOIS_EN[mois.replace('.', '').toLowerCase()];
        if (en && !/[À-ÿ]/.test(mois) && !/\.$/.test(mois)) mois = en;
        var out = parseInt(m[2], 10) + ' ' + mois + (m[3] ? ' ' + m[3] : '');
        if (m[4]) {
          var h = parseInt(m[4], 10);
          var ap = (m[6] || '').charAt(0).toLowerCase();
          if (ap === 'p' && h < 12) h += 12;
          if (ap === 'a' && h === 12) h = 0;
          out += ' à ' + h + ' h ' + m[5];
        }
        return out;
      }
      function suiviDates(app) {
        app.querySelectorAll('.timeline-item__timestamp span, .timeline-item__timestamp, .text-wrapper span, .progress-bar-mobile-content span').forEach(function (el) {
          if (el.children.length) return;
          var t = el.textContent;
          var fr = suiviDateFr(t);
          if (fr !== t) el.textContent = fr;
        });
      }
      function traduitSuivi(app) {
        suiviDates(app);
        app.querySelectorAll('.timeline-body-content span, .PP-GoogleMap-PlaceCard__LocationAddress').forEach(function (el) {
          if (el.children.length) return;
          if (el.classList.contains('PP-GoogleMap-PlaceCard__LocationAddress') && !/(^|[,\s])(FR|FRANCE)\s*$/i.test(el.textContent.trim())) {
            var carte = el.closest('[class*="PlaceCard"]:not(.PP-GoogleMap-PlaceCard__LocationAddress)') || el.parentElement;
            if (carte) carte.style.display = 'none';
            return;
          }
          if (el.classList.contains('PP-GoogleMap-PlaceCard__LocationAddress')) return;
          var t = el.textContent;
          if (!t || el.getAttribute('data-suivi-fr') === t) return;
          var fr = suiviFrTexte(t);
          if (fr !== t) el.textContent = fr;
          el.setAttribute('data-suivi-fr', fr);
        });
      }

      
  function habillePP() {
    var app = document.getElementById('pp-tracking-page-app');
    if (!app) return;
    traduitSuivi(app);
    app.querySelectorAll('input[name="order"]').forEach(function (i) { i.placeholder = '#1234'; });
    app.querySelectorAll('input[name="email"]').forEach(function (i) { i.placeholder = 'vous@exemple.fr'; });
    app.querySelectorAll('input[name="nums"]').forEach(function (i) { i.placeholder = 'Ex. LA123456789FR'; });
    /* Repli si :has() non supporté. */
    app.querySelectorAll('a[href*="parcelpanel"], a[href*="cwill.com"]').forEach(function (a) {
      var parent = a.closest('div');
      if (parent) parent.style.display = 'none';
    });
  }

  function init() {
    initTimeline();
    habillePP();
    if (!window.__kddSuiviObs && document.getElementById('pp-tracking-page-app')) {
      window.__kddSuiviObs = new MutationObserver(habillePP);
      window.__kddSuiviObs.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
